import { MessageState, ON_MESSAGE, REMOVE_MESSAGE } from './types';

interface Action {
  type: string;
  payload: MessageState;
}

const initialState: MessageState = {
  description: '',
};

export const messageReducer = (state = initialState, { type, payload }: Action) => {
  switch (type) {
    case ON_MESSAGE:
      return { ...payload };
    case REMOVE_MESSAGE:
      return { ...initialState };
    default:
      return state;
  }
};
